module.exports = __webpack_public_path__ + "static/media/my-booking.ce14e3b4.png";